import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { invalidateCatalogQueries } from "@/entities/thread";
import { apiPut } from "@/shared/api";
import { getApiErrorMessage } from "@/shared/ui/feedback/apiErrorMessage";
import { toast } from "@/shared/ui/toast";

interface ReactionResponse {
  postId: string;
  type: "del";
}

export function useDelMutation(): UseMutationResult<
  ReactionResponse,
  unknown,
  string
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (postId: string) => {
      return apiPut<ReactionResponse>(`/posts/${postId}/reactions/del`, {
        requiresToken: true,
      });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["thread"] });
      void invalidateCatalogQueries(queryClient);
      console.info("delしました");
    },
    onError: (error: unknown, postId: string) => {
      console.warn("delに失敗しました", { error, postId });
      toast.error(getApiErrorMessage(error, "delの送信に失敗しました"));
    },
  });
}
